export const NAV_ROUTES = {
  onExit: "/MockTest",
  onError: "/Mocktest",
  onEnd: "/MockTest",
};

export const navigateToExit = (navigate, path = NAV_ROUTES.onExit) => {
  if (typeof navigate === "function") navigate(path);
};

export const navigateOnError = (navigate, path = NAV_ROUTES.onError, delayMs = 2000) => {
  if (typeof navigate === "function") {
    setTimeout(() => navigate(path), delayMs);
  }
};

export const navigateOnEnd = (navigate, path = NAV_ROUTES.onEnd) => {
  if (typeof navigate === "function") navigate(path);
};

export const navigateToScoreOrHome = (navigate, attemptId, isSectional = false, typeOfTest = null) => {
  if (!navigate) return;
  const target = isSectional 
    ? `/mt-score-viewscore-sectional/${attemptId}${typeOfTest ? `/${typeOfTest}` : ''}` 
    : `/mt-score-viewscore/${attemptId}`;
  navigate(target);
};


